var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValveBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VALVE_BOX",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #VALVE_BOX .cls-1 {\n        fill: #3e4346;\n      }\n\n      #VALVE_BOX .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_393",
    "data-name": "Pfad 393",
    className: "cls-1",
    d: "M18,0A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_394",
    "data-name": "Pfad 394",
    className: "cls-2",
    d: "M5,5V26H26V5ZM15.5,15.5,6.65,24.35h0V6.65h0L15.5,15.5l8.85-8.85v17.7Z",
    transform: "translate(2.5 2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValveBox);
export default __webpack_public_path__ + "static/media/valve-box.25b108de32ab01f55d0fdd7fd003aa04.svg";
export { ForwardRef as ReactComponent };